export function formatBytes(bytes: number) {
  const units = ['b', 'Kb', 'Mb', 'Gb', 'Tb']
  let unitIndex = 0

  while (bytes >= 1024 && unitIndex < units.length - 1) {
    bytes /= 1024
    unitIndex++
  }

  return `${bytes.toFixed(2)} ${units[unitIndex] ?? ''}`
}
